import { parseJwtToken } from './jwt_token';
import { ForbiddenError } from '..';
export function isCompanyUserToken(idToken) {
    const data = parseJwtToken(idToken);
    const companyUserKeys = [
        'custom:streem_user_id',
        'custom:streem_company_id',
        'custom:streem_company_code',
        'streem_account_code',
    ];
    const loginIdentityKey = 'custom:streem_login_identity_id';
    // different company users may have different keys
    // one match is enough to validate that they are a streem company user
    return (companyUserKeys.some(key => Object.prototype.hasOwnProperty.call(data, key)) &&
        !data[loginIdentityKey]);
}
export function getCompanyUserFromToken(idToken, oauthCredentials) {
    const idTokenData = typeof idToken === 'string' ? parseJwtToken(idToken) : idToken;
    const companyCode = getCompanyCodeFromIdToken(idToken);
    if (companyCode === undefined) {
        throw new ForbiddenError(`You do not have access to this company. Token subject: '${idTokenData.sub}'`);
    }
    return {
        id: oauthCredentials.streem_user_id,
        companyCode,
        avatarUrl: idTokenData.picture,
        name: idTokenData.name,
        email: idTokenData.email,
        scope: oauthCredentials.scope,
    };
}
export function getCompanyCodeFromIdToken(idToken) {
    const data = typeof idToken === 'string' ? parseJwtToken(idToken) : idToken;
    return data['streem_account_code'] || data['custom:streem_company_code'];
}
//# sourceMappingURL=company_user.js.map